module.exports = __webpack_public_path__ + "static/img/imperial_rabbit_2.97689fd.png";